import apiClient from "../../utils/apiClient";

const getComments = (path, cursor, isCustomPath) => {
    const url = isCustomPath
        ? `${path}${cursor ? `?cursor=${cursor}` : ''}`
        : `${path}/comments${cursor ? `?cursor=${cursor}` : ''}`;
    return apiClient.get(url);
};

const addComment = (path, data) => {
    const url = `${path}/comments`;
    return apiClient.post(url, data);
};

const updateComment = (path, data, commentId) => {
    const url = `${path}/comments/${commentId}`;
    return apiClient.put(url, data);
};

const deleteComment = (path, commentId) => {
    const url = `${path}/comments/${commentId}`;
    return apiClient.delete(url);
};

const likeComment = (path, commentId) => {
    const url = `${path}/comments/${commentId}/like`;
    return apiClient.post(url);
};

const getCommentDetails = (id) => {
    const url = `/comments/${id}`;
    return apiClient.get(url);
};

const getCommentReplies = (id, cursor) => {
    const url = `/comments/${id}/replies${cursor ? `?cursor=${cursor}` : ''}`;
    return apiClient.get(url);
};

export const CommentsService = {
    getComments,
    addComment,
    likeComment,
    updateComment,
    deleteComment,
    getCommentDetails,
    getCommentReplies
};